import { useRef, useState } from 'react';
import { useEventListener } from 'usehooks-ts';

export default function useDocumentVisible() {
  const documentRef = useRef(document);
  const [documentVisible, setDocumentVisible] = useState(() => document.visibilityState === 'visible');

  useEventListener(
    'visibilitychange',
    () => {
      setDocumentVisible(document.visibilityState === 'visible');
    },
    documentRef,
  );

  return documentVisible;
}
